import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { ManageNotificationsStore } from "../stores/manageNotificationsStore";

export const useManageNotificationsStore = () => useContext<{
  manageNotificationsStore: ManageNotificationsStore;
}>(StoreContext);